export const mutateAdminTeamMembers = (data, items) => {
	(data ?? []).forEach(elem => {
		const feedItem = items.find(entity => elem.id === entity.id);
		if (feedItem) {
			feedItem.adminTeamMemberData = elem.adminTeamMembers;
			feedItem.adminTeamMembers = elem.adminTeamMembers.map(member => member.fullName).join(", ");
		}
	});
};
